import { useTranslation } from "react-i18next";

export default function ClientSlotsWidget() {
  const { t } = useTranslation();

  return (
    <div
      className="dyna-client-slots"
      style={{
        position: "relative",
        isolation: "isolate",
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        background: "rgba(90,70,102,0.3)",
        border: "1px solid var(--lavender-500)",
        borderRadius: 999,
        padding: "8px 20px",
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 11,
        textTransform: "uppercase",
        letterSpacing: "0.14em",
        color: "var(--lavender-300)",
      }}
    >
      {/* dangerouslySetInnerHTML avoids React's text-content escaping, which
          turns CSS `content: ""` into `content: &quot;&quot;` at SSR — the
          mismatch with the un-escaped client expectation triggers React's
          hydration error #418. */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        .dyna-client-slots::before {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: inherit;
          box-shadow: 0 0 18px 2px rgba(135,115,180,0.45);
          pointer-events: none;
          z-index: -1;
          opacity: 0;
          animation: clientSlotsGlowPulse 2.5s ease-in-out infinite;
          will-change: opacity;
        }
        @keyframes clientSlotsGlowPulse {
          0%, 100% { opacity: 0; }
          50%      { opacity: 1; }
        }
      `,
        }}
      />
      <span>{t("dyna.clientSlots.label")}</span>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--lavender-300)" }} />
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--lavender-300)" }} />
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "transparent", border: "1px solid var(--lavender-500)" }} />
      </span>
    </div>
  );
}
